import { render, staticRenderFns } from "./ArchivedReward.vue?vue&type=template&id=63395093&"
import script from "./ArchivedReward.vue?vue&type=script&lang=js&"
export * from "./ArchivedReward.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports